<template>
  <div class="page p-login">
    <div class="page-header">
      <img src="../assets/logan.png" alt="Logan icon" />
      <div class="title">Logan log helper</div>
    </div>
    <v-card dark width="350px" class="card-login">
      <form @submit.prevent="onSubmit">
        <v-row>
          <v-col class="card-title">Login</v-col>
          <v-col cols="12">
            <v-text-field
              value="lifeapps"
              label="Usuário"
              dark
              outlined
              dense
              readonly
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="senha"
              label="Senha"
              dark
              outlined
              dense
              :type="visibled ? 'text' : 'password'"
              :append-icon="visibled ? 'fas fa-eye' : 'fas fa-eye-slash'"
              @click:append="visibled = !visibled"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-btn
              color="secondary"
              rounded
              large
              dark
              width="100%"
              type="submit"
              :loading="loading"
              >Buscar</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </v-card>
    <v-snackbar
      v-model="snackbar.open"
      :color="snackbar.color"
      left
      :timeout="1000"
    >
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import { Login } from '../service/Api'
import * as _ from 'lodash'

export default {
  name: 'Login',
  data: () => ({
    senha: '',
    snackbar: {
      open: false,
      color: '',
      message: '',
    },
    loading: false,
    visibled: false
  }),
  methods: {
    onSubmit() {
      this.loading = true
      Login(this.senha)
        .then(data => {
          this.snackbar = {
            open: true,
            color: 'success',
            message: 'Acesso autorizado, redirecionando',
          }
          localStorage.setItem('authorization', _.get(data, 'data.data.token'))
          setTimeout(() => this.$router.push('/'), 500)
          this.loading = false
        })
        .catch(err => {
          this.snackbar = {
            open: true,
            color: 'error',
            message: _.get(
              err,
              'response.data.message',
              _.get(err, 'message', 'Falha ao efetuar login')
            ),
          }
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
.p-login {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .card-login {
    margin-top: 80px;
    padding: 15px;
    .card-title {
      font-size: 18px;
      font-weight: 800;
    }
  }
  .page-header {
    padding: 0;
    height: 100px;
    border-bottom: none;
    flex: none;
    text-align: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    img {
      max-width: 100px;
      max-height: 100px;
      width: auto;
      height: auto;
    }
    .title {
      margin-top: 5px;
      color: #fff;
      font-size: 18px;
    }
  }
}
</style>
